import React from 'react';
import classNames from 'classnames';
import { NamedLink } from '../../../components';
import css from './CommonSection.module.css';

const CommonSection = (props) => {
    const {
        title,
        text,
        linkText,
        linkName,
        linkParams = {},
        linkTo = {},
        className,
        hideLink = false,
    } = props;

    return <div className={classNames(css.root, className)}>
        <h3 className={css.title}>
            {title}
        </h3>

        {text ? <p className={css.text}>
            {text}
        </p> : null}

        {hideLink ? null : <NamedLink
            name={linkName}
            params={linkParams}
            to={linkTo}
            className={css.whiteLink}
        >
            {linkText}
        </NamedLink>}
    </div>
};

export default CommonSection;
